<script>
import { Cell, RadioGroup, Radio } from 'vant'

export default {
    //--------------------------------------------------
	// component name
	//--------------------------------------------------
    name: 'radio-group-field',

    //--------------------------------------------------
	// component components
	//--------------------------------------------------
    components: {
        'van-cell': Cell,
        'van-radio-group': RadioGroup,
        'van-radio': Radio,
    },

    //--------------------------------------------------
    // component props
    //--------------------------------------------------
    props: {
        label: String,
        groupList: Array,
        value: String,
        disabled: Boolean,
	},

    //--------------------------------------------------
    // component emits
    //--------------------------------------------------
	emits: ['change-data'],

    //--------------------------------------------------
    // component data
    //--------------------------------------------------
    data() {
        return {
            selectedRadio: null,
        }
    },

    //--------------------------------------------------
    // computed setter and getter
    //--------------------------------------------------
    computed: {
        selectedRadioField: {
            get() {
                return this.selectedRadio ? this.selectedRadio : this.value
            },
            set(value) {
                this.selectedRadio = value
            }
        }
    },

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    methods: {
        onRadioClick() {
            console.log('onRadioClick', this.selectedRadio)
            this.$emit('change-data', this.selectedRadio)
        }
    },
}
</script>

<template>
    <!-- component -->
    <div class="radio-group-field van-cell no-padding">
        <van-cell 
            :title="label"
            :class="{ disabled: disabled }"
            center
        >
            <template #default>
                <van-radio-group 
                    class="justify-right"
                    v-model="selectedRadioField"
                    direction="horizontal"
                    :disabled="disabled"
                >
                    <van-radio 
                        v-for="item in groupList" 
                        :key="item.value"
                        :name="item.value"
                        @click="onRadioClick"
                    >
                        {{ item.label }}
                    </van-radio>
                </van-radio-group>
            </template>
        </van-cell>
    </div>
</template>

<style scoped>
.radio-group-field .van-cell__value {
    flex: 3;
}
.radio-group-field .van-radio--horizontal {
    margin-left: 12px;
    margin-right: 0;
}
.radio-group-field .van-radio {
    margin-top: 2px;
}
</style>